<div class="fxflex fxstartcenter full-height links-container" data-cy="links-container">
  @for (route of routes; track route.name) {
    <rtr-button
      type="tertiary"
      class="header-link"
      [text]="'Layout.' + route.name"
      [dataCy]="'header-' + route.name"
      (click)="navigate.emit(route)"
    />
  }
</div>
